module.exports = __webpack_public_path__ + "static/media/rss-square.f51e29ba.svg";